import { Language } from 'assets/locales/Locale';
import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import Model from 'models/Model';
import ProductTransferOwnershipFillablePdfField from '../productTransferOwnershipFillablePdfField/Model.ProductTransferOwnershipFillablePdfField';
import productTransferOwnershipDocumentFindApi from './find/Api.ProductTransferOwnershipDocument.Find';
import productTransferOwnershipDocumentSaveApi from './save/Api.ProductTransferOwnershipDocument.Save';
import productTransferOwnershipDocumentDeleteApi from './delete/Api.ProductTransferOwnershipDocument.Delete';

export default class ProductTransferOwnershipDocument
  extends Model<Model.IProductTransferOwnershipDocument>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProductTransferOwnershipDocument>
{
  id: number;
  productId: number;
  orderNumber: number;
  mediaFileId: number;
  mediaFile: MediaFile;
  formFile?: File;
  documentCategory: Model.Enum.EngineType;
  fillablePdfFields: Array<ProductTransferOwnershipFillablePdfField>;
  languageIsoCode?: Locale.Languages = Language.english;

  constructor(
    data: Partial<Model.IProductTransferOwnershipDocument> | Utils.FormData<Model.IProductTransferOwnershipDocument>,
    language?: Locale.Languages
  ) {
    super(
      {
        mediaFile: MediaFile,
        fillablePdfFields: [ProductTransferOwnershipFillablePdfField],
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.mediaFile?.name || this.id.toString(),
    };
  }
  static async find(params: Api.Core.ProductTransferOwnershipDocument.Find.IRequest) {
    const { payload, ...rest } = await productTransferOwnershipDocumentFindApi(params);
    return {
      ...rest,
      payload: payload ? new ProductTransferOwnershipDocument(payload) : null,
    };
  }
  async save() {
    return await productTransferOwnershipDocumentSaveApi(this);
  }
  async delete() {
    return await productTransferOwnershipDocumentDeleteApi({ productId: this.productId, documentId: this.id });
  }
}
